module.exports = __webpack_public_path__ + "img/love-paws-homestay-dogs.1a2b925a.jpg";